var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.html';
var html = "TestWidget for {{$ctrl.project.title}} ({{$ctrl.project.apikey}})";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.html
// module id = 1415
// module chunks = 0